export default __webpack_public_path__ + "static/media/Blank-Furnished.4d826b26.png";